import Vue from 'vue';
import BlackTip from './component/Toast.vue';
import Confirm from './component/Confirm.vue';
import Alert from './component/Alert.vue';
import i18n from '@/i18n';

const BlackTipComponent = Vue.extend(BlackTip);

const  $Toast = function (config, time = 1500, mountedEl?) {
  const el: any = new BlackTipComponent().$mount();
  if (typeof config === 'string') {
    el.msgText = config;
  } else {
    // const { text, type, maxWidth } = config;
    const { text, maxWidth } = config;
    el.msgText = text;
    el.maxWidth = maxWidth || 240;
    // el.type = type || 'success';
  }
  el.visible = true;
  if (mountedEl) {
    mountedEl.appendChild(el.$el);
  } else {
    let currentMountedEl = document.body;
    if (Vue.prototype.$platform.pc) {
      currentMountedEl = document.querySelector('.im-main-container>.im-msg-container') || document.body;
    }
    currentMountedEl.appendChild(el.$el);
  };
  setTimeout(() => {
    el.visible = false;
    setTimeout(() => {
      el.$destroy();
    });
  }, time);
};

const ConfirmComponent = Vue.extend(Confirm);

const $Confirm = function (config, mountedEl?) {
  const el: any = new ConfirmComponent({ i18n }).$mount();
  if (typeof config === 'string') {
    el.title = config;
  } else {
    const { text, cancelText, confirmText, title } = config;
    el.text = text;
    el.title = title;
    el.cancelText = cancelText;
    el.confirmText = confirmText;
  }

  el.visible = true;
  if (mountedEl) {
    mountedEl.appendChild(el.$el);
  } else {
    document.body.appendChild(el.$el);
  };
  return new Promise((resolve, reject) => {
    el.confirm = function () {
      el.visible = false;
      resolve(true);
      setTimeout(() => {
        el.$destroy();
      });
    };
    el.cancel = function () {
      el.visible = false;
      reject(false);
      setTimeout(() => {
        el.$destroy();
      });
    };
  });
};

const AlertComponent = Vue.extend(Alert);

const $Alert = function (config, mountedEl?) {
  const el: any = new AlertComponent({ i18n }).$mount();
  if (typeof config === 'string') {
    el.title = config;
  } else {
    const { text, alertText, title } = config;
    el.text = text;
    el.alertText = alertText;
    el.title = title;
  }
  el.visible = true;
  if (mountedEl) {
    mountedEl.appendChild(el.$el);
  } else {
    document.body.appendChild(el.$el);
  };
  return new Promise((resolve, reject) => {
    el.confirm = function () {
      el.visible = false;
      resolve(true);
      setTimeout(() => {
        el.$destroy();
      });
    };
    el.cancel = function () {
      el.visible = false;
      reject(false);
      setTimeout(() => {
        el.$destroy();
      });
    };
  });
};


export default {
  install() {
    if (!Vue.prototype.$Toast) {
      Vue.prototype.$Toast = $Toast;
      Vue.prototype.$Confirm = $Confirm;
      Vue.prototype.$Alert = $Alert;
    }
  },
};

